class Modal {

    constructor(oParams) {
        
        this.params = oParams;

        this.id = typeof this.params.id != 'undefined'
            ? this.params.id
            : this.getRandomId();
        this.title = this.params.title;
        this.content = this.params.content;
        this.size = typeof this.params.size != 'undefined' 
            ? ' '+this.params.size
            : '';
        this.class = typeof this.params.class != 'undefined'
            ? ' '+this.params.class
            : '';

        this.class_footer = typeof this.params.class_footer != 'undefined'
            ? ' '+this.params.class_footer
            : '';

        this.static = typeof this.params.static == 'undefined'
            ? false
            : this.params.static;

        this.callBack = this.params.callBack   
            ? this.params.callBack
            : null;
        
        this.buttons = [];
       // this.buttons.push('<button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>');
        if (this.params.buttons){
            for (var i = 0; i < this.params.buttons.length; ++i) {
                this.buttons.push(this.params.buttons[i]);
            }
        }

        this.create();

        this.eventRemove();
    }

    create() {

        let sHtml = '',
            staticData = '';

        if (this.static) {
            staticData = ' data-backdrop="static" data-keyboard="false"';
        }

        
        sHtml += '<div class="modal fade" id="'+this.id+'" role="dialog"'+staticData+'>';
            sHtml += '<div class="modal-dialog modal-dialog-centered'+this.class+this.size+'" role="document">';
                sHtml += '<div class="modal-content">';

                    sHtml += '<div class="modal-header">';
                        sHtml += '<h5 class="modal-title">'+this.title+'</h5>';
                        sHtml += '<button type="button" class="close" data-dismiss="modal">';
                            sHtml += '<span>&times;</span>';
                        sHtml += '</button>';
                    sHtml += '</div>';

                    sHtml += '<div class="modal-body"></div>';
                    
                    if (this.buttons.length > 0) {
                        sHtml += '<div class="modal-footer" class="'+this.class_footer+'">'+this.buttons.join('')+'</div>';
                    }

                sHtml += '</div>';
            sHtml += '</div>';
        sHtml += '</div>';

        const $html = $(sHtml);
        $html.find('.modal-body').html(this.content)

        $("body").append($html);

        let callBack = this.callBack;
        
        if (this.callBack) {
            $('#'+this.id).on('shown.bs.modal', function () {
                callBack();
            });
        }

        $('#'+this.id).modal('toggle');
    }

    eventRemove() {
        $('#'+this.id).on('hidden.bs.modal', function (e) {
            $('#'+this.id).remove();
        });
    }

    getRandomId() {
        return  Math.random().toString(36).substring(2, 15);
    }

}